/*
 * ПРИМЕР ИСПОЛЬЗОВАНИЯ:
 * await QuestionnairesService.readOne<{ payload: TPaymentSchedule[] }, TReadParamsProperties>({
 *            identifier: `${number}/payment-schedule`,
 *            headers: {
 *              ...getHeaderAcceptLanguage(locale),
 *            }
 * });
 */

export const getHeaderAcceptLanguage = (
    locale?: string,
): {
    [key: string]: string;
} => {
    return {
        'Accept-Language': locale === 'ru' ? 'ru-RU' : 'kk-KZ',
    };
};
